import { SelectSearchOption } from '../../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { Doctorcatalog } from '../../../mdqx-graphql-types';

export class DoctorCatalogEntity implements SelectSearchOption<DoctorCatalogEntity> {
    constructor(public Id: number, public Name: string) {}
    get optionLabel() {
        return this.Name;
    }
    static readonly GqlFields: Array<keyof Doctorcatalog> = ['id', 'name'];
    static fromBackend(res: Doctorcatalog) {
        return new DoctorCatalogEntity(res.id, res.name);
    }
}
